module.exports = __webpack_public_path__ + "img/safety-active.512908b8.svg";